require('slick-carousel');

let carousel = $('.offer-list .infinite-container');

export default {
  fire() {
    carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      arrows: false,
      mobileFirst: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 541,
          settings: { slidesToShow: 2, slidesToScroll: 2 },
        },
        {
          breakpoint: 812,
          settings: { slidesToShow: 3, slidesToScroll: 3 },
        },
        {
          breakpoint: 1083,
          settings: { slidesToShow: 4, slidesToScroll: 4, variableWidth: false, dots: true, swipe: false },
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/components/offer-carousel.js